<template>
  <div class="message-wrapper">
    <div v-if="isDataTypeOther" style="align-self: center">
      <span class="text-caption">
        {{ message.content }}
      </span>
    </div>
    <div
      v-else-if="message.content || message.image"
      class="message-container"
      :class="{ sender: senderTypeNotStudent }"
    >
      <div
        v-if="message.image"
        class="message"
        :class="{ ours: senderTypeNotStudent, 'ours-image': isMessageImage, 'ours-content': senderTypeNotStudent }"
      >
        <img v-img :src="message.image.url" class="image-message sender" />
        <br />
      </div>
      <div v-if="message.content" class="message" :class="{ ours: senderTypeNotStudent }">
        <span>
          {{ message.content }}
        </span>
      </div>
    </div>

    <!-- time -->
    <div v-if="isDataTypeOther" class="time" style="align-self: center">
      <span class="text-caption">
        {{ message.time | ddmmyyyyhhmm }}
      </span>
    </div>
    <div v-else-if="message.content || message.image" class="time" :class="{ sender: senderTypeNotStudent }">
      {{ message.time | ddmmyyyyhhmm }}
    </div>
  </div>
</template>
<script>
import { get } from 'lodash'

export default {
  props: { message: Object },
  computed: {
    senderTypeNotStudent() {
      return get(this.message, 'sender.type') !== 'student'
    },
    isDataTypeOther() {
      return get(this.message, 'data.type') === 'other'
    },
    isMessageImage() {
      const imageUrl = get(this.message, 'image.url', '')
      return typeof imageUrl === 'string' && imageUrl.length > 0
    },
  },
}
</script>
<style lang="scss" scoped>
.message-wrapper {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.message-container {
  max-width: 70%;
}

.sender {
  align-self: flex-end;
}

.message {
  background: gray;
  color: white;
  padding: 8px 12px;
  border-radius: 16px;
  word-wrap: break-word;
}

.time {
  /* white-space: nowrap; */
  color: grey;
  font-size: 11px;
  margin-bottom: 16px;
}

.ours {
  background: #0076ff;
  .ours-image {
    background: transparent;
  }
  .ours-content {
    text-align: end;
  }
}

.image-message {
  width: 70%;
  object-fit: contain;
  cursor: pointer;
}
</style>
